import { useContext } from 'react';
import { StoreContext } from './../context';
import { BaseStore } from '../stores';

export const useBaseStore = () => useContext<BaseStore>(StoreContext);
